
import { defineComponent } from "vue";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  emits: ["updateParent"],
  props: {
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
    selectMode: { required: false, type: Boolean, default: false },
  },
  methods: {
    async refreshParent() {
      const { data } = await api.get("/PlanPackage/GetEditModel", {
        params: {
          id: this.parentModel.id,
          idParent: this.parentModel.idParent,
        },
      });
      this.$emit("updateParent", data);
    },
  },
  data() {
    return {
      columns: [
        new IntegerColumnConfig({
          dataField: "length",
          caption: "Длина (мм)",
          min: 0,
          validationRules: [requiredRule],
        }),
        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 0,
          min: 0,
          step: 1,
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        hoverStateEnabled: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: true,
      }),
      editingConfig: new TableEditingConfig({
        allowUpdating: (this.parentEditingConfig as any)?.allowUpdating,
        allowAdding: (this.parentEditingConfig as any)?.allowAdding,
        allowDeleting: (this.parentEditingConfig as any)?.allowDeleting,
        allowDeleteAll: (this.parentEditingConfig as any)?.allowDeleteAll,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
        mode: "row",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
  },
});
